/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Chat_Steps_Thought_ForInputs */



/**
* | output |
* | --- |
* | "Thought for {duration}" |
*
* @param {Chat_Steps_Thought_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_steps_thought_for = /** @type {((inputs: Chat_Steps_Thought_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Steps_Thought_ForInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Habe ${i?.duration} nachgedacht`)
	return /** @type {LocalizedString} */ (`Thought for ${i?.duration}`)
});